"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isInternetExplorer = void 0;
function isInternetExplorer() {
    return window.navigator.userAgent.indexOf('MSIE ') > 0;
}
exports.isInternetExplorer = isInternetExplorer;
//# sourceMappingURL=browser.js.map